import React from 'react';

export default () => (
  <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1">
    <title>chart-symbol-diamond</title>
    <desc>Created with Sketch.</desc>
    <g id="chart-symbol-diamond" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <polygon id="Polygon-Copy-2" fill="#14D997" fillRule="nonzero" points="6 0 12 6 6 12 0 6" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/chart-symbol-diamond.es6.js